// extracted by mini-css-extract-plugin
export var checkbox = "_5s-0";
export var circle = "_5s-3";
export var horizontalContainer = "_5s-7";
export var sm = "_5s-5";
export var switch0 = "_5s-2";
export var switchDisabled = "_5s-8";
export var switchEnabled = "_5s-1";
export var textSwitchContainer = "_5s-9";
export var textSwitchOption = "_5s-a";
export var textSwitchOptionSelected = "_5s-b";
export var verticalContainer = "_5s-6";
export var xs = "_5s-4";